<template>
  <section class="content">
    <div class="row">
      <div
        v-if="getRoleType === 99"
        class="col-xs-12 p-x-0 m-b-10 flex align-center"
      >
        <router-link :to="goBackInfo">
          <div class="btn btn-default m-r-5 flex">
            <span>返回</span>
            <span v-text="goBackInfo.title" />
            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="box">
          <!-- box-header -->
          <div class="box-header">
            <div class="row">
              <div class="col-sm-8 text-left">
                <div class="font-size-subtitle-2 font-weight-regular">
                  <span class="text-red">＊</span>
                  <span>此區可新增、編輯品牌下所有菜單的內容</span>
                </div>
                <div class="font-size-subtitle-2 font-weight-regular">
                  <span class="text-red">＊</span>
                  <span>黑名單：名單內的門市當進行配料庫複製時「不可」被覆寫，菜單上架時「不可」被複寫</span>
                </div>
              </div>
              <div class="col-sm-4 text-right">
                <div class="form-inline">
                  <div class="form-group">
                    <select class="form-control h-38">
                      <option value="1">關鍵字</option>
                    </select>
                  </div>
                  <div class="form-group search-bar">
                    <div class="input-group">
                      <input v-model="searchKeyword" class="form-control" type="text">
                      <span class="input-group-addon c-pointer" @click="clickPage(1)">
                        <i class="fa fa-search"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- End box-header -->

          <!-- box-body -->
          <div class="box-body">
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table
                  v-if="list"
                  class="table table-bordered table-striped"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th class="w-xl">品牌</th>
                      <th>門市</th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, k) in list" :key="k">
                      <td v-text="k + 1" />
                      <td>
                        <a
                          :href="`${webDomain}menu/${item.id}`"
                          target="_blank"
                        >
                          <img
                            class="w-100 rounded"
                            :src="item.image"
                          />
                        </a>
                      </td>
                      <td v-text="item.name || item.name_short" />
                      <td>
                        <router-link 
                          v-if="getRoleType === 10" 
                          :to="{
                            name: 'brandMenu',
                            params: {
                              brand_id: item.id
                          }
                        }">
                          <button class="btn btn-default">
                            <i class="fa fa-plus-square" />
                            配料庫
                          </button>
                        </router-link>
                        <router-link 
                          v-else :to="{
                          name: 'StoreMenuStep',
                          params: {
                            store_id: item.id
                          }
                        }">
                          <button class="btn btn-default">
                            <i class="fa fa-plus-square" />
                            配料庫
                          </button>
                        </router-link>
                      </td>
                      <td>
                        <router-link 
                          v-if="getRoleType === 10" 
                          :to="{
                            name: 'brandMenuTable',
                            params: {
                              brand_id: item.id
                            }
                          }"
                        >
                          <button class="btn btn-default">
                            <i class="fa fa-wrench" />
                            菜單建置
                          </button>
                        </router-link>
                        <router-link v-else :to="{
                          name: 'StoreMenuBuild',
                          params: {
                            brand_id: $route.params.brand_id,
                            store_id: item.id
                          }
                        }">
                          <button class="btn btn-default">
                            <i class="fa fa-wrench" />
                            菜單建置
                          </button>
                        </router-link>
                      </td>
                      <td>
                        <router-link :to="{
                          name: 'StoreMenuImage',
                          params: {
                            brand_id: $route.params.brand_id,
                            store_id: item.id
                          }
                        }">
                          <button class="btn btn-default">
                            <i class="fa fa-picture-o" />
                            圖片庫
                          </button>
                        </router-link>
                      </td>
                      <td>
                        <router-link :to="{
                          name: 'StoreMenuSetting',
                          params: {
                            brand_id: $route.params.brand_id,
                            store_id: item.id
                          }
                        }">
                          <button class="btn btn-default">
                            <i class="fa fa-certificate" />
                            別名 / 描述 / 警語
                          </button>
                        </router-link>
                      </td>
                      <td>
                        <router-link 
                          v-if="getRoleType === 10" 
                          :to="{
                            name: 'brandScheduleTable',
                            params: {
                              brand_id: item.id,
                            }
                          }"
                        >
                          <button class="btn btn-primary">
                            <i class="fa fa-clock-o" />
                            排程管理
                          </button>
                        </router-link>
                        <router-link v-else :to="{
                          name: 'StoreMenuSchedule',
                          params: {
                            brand_id: $route.params.brand_id,
                            store_id: item.id
                          }
                        }">
                          <button class="btn btn-primary">
                            <i class="fa fa-clock-o" />
                            排程管理
                          </button>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <paginate
                :clickPage="clickPage"
                :groupAmount="paginate.count"
                :isActive="isActive"
                :pageAmount="pageAmount"
                ref="brandPaginate"
                :total="paginate.total"
              />
            </div>
          </div>
          <!-- End box-body -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// utils
import qs from 'qs'
// vue
import { mapGetters } from 'vuex'
// components
import NidinModal from '@/components/elements/Modal'
// extends
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'StoreMenu',
  components: {
    'nd-modal': NidinModal
  },
  data () {
    return {
      paginate: {
        count: 10,
        pageGroup: 1,
        tableIndex: 1,
        total: 1
      },
      list: [],
      searchKeyword: ''
    }
  },
  extends: NdExtendHandleMenu,
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.paginate.total / this.paginate.count)
    },
    webDomain () {
      return this.$config.web
    }
  },
  mounted () {
    this.setPaginate()
    this.getList()
    this.getExtendHandleMenuInfo()
  },
  methods: {
    isActive (index) {
      return Number(this.paginate.tableIndex) === index
    },
    clickPage (index) {
      this.paginate.tableIndex = index
      this.getList()
    },
    getList () {
      const brandId = this.$route.params.brand_id
      const data = {
        allow_copy_menu: 0,
        page: this.paginate.tableIndex,
        size: this.paginate.count,
        name: this.searchKeyword
      }
      const url = `brand/${brandId}/storeList?${qs.stringify(data)}`

      this.$router.replace({
        query: {
          ...this.$route.query,
          page: this.paginate.tableIndex,
          size: this.paginate.count
        }
      })
      this.getDataH('get', url, null, (res) => {
        if (res.data.status === 200) {
          this.list = res.data.list
          this.paginate.total = res.data.list_total
        }
      })
    },
    setPaginate () {
      if (this.$route.query.page) {
        this.paginate.tableIndex = Number(this.$route.query.page)
      }
      if (this.$route.query.size) {
        this.paginate.count = Number(this.$route.query.size)
      }
      this.$refs.brandPaginate.pageGroup = this.paginate.pageGroup
      this.$refs.brandPaginate.tableIndex = this.paginate.tableIndex
    }
  }
}
</script>

<style lang="scss" scoped>
.font-size-subtitle-2 {
  font-size: 14px;
}
.font-weight-regular {
  font-weight: 400;
}
.rounded {
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// store-menu.vue?7d35d11d